/**
 * Utility to handle caching with expiry in localStorage
 */

/**
 * Save data to localStorage with an expiry time
 * @param {string} key - Unique identifier for the cache
 * @param {any} value - Data to be cached
 * @param {number} expiryInSeconds - Expiry time in seconds
 */
export const setCache = (key, value, expiryInSeconds) => {
    try {
        const now = new Date();
        const expiryTime = now.getTime() + expiryInSeconds * 1000;

        const cacheItem = {
            value,
            expiry: expiryTime,
        };

        localStorage.setItem(key, JSON.stringify(cacheItem));
    } catch (error) {
        console.error('Error setting cache:', error);
    }
};

/**
 * Retrieve data from localStorage if not expired
 * @param {string} key - Unique identifier for the cache
 * @returns {any|null} - Cached data or null if expired/not found
 */
export const getCache = (key) => {
    try {
        const cacheItem = localStorage.getItem(key);

        if (!cacheItem) {
            return null;
        }

        const { value, expiry } = JSON.parse(cacheItem);
        const now = new Date();

        if (now.getTime() > expiry) {
            localStorage.removeItem(key);
            return null;
        }

        return value;
    } catch (error) {
        console.error('Error getting cache:', error);
        return null;
    }
};

/**
 * Clear specific cache by key
 * @param {string} key - Unique identifier for the cache
 */
export const clearCache = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error('Error clearing cache:', error);
    }
};

/**
 * Clear all cache in localStorage
 */
export const clearAllCache = () => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error('Error clearing all cache:', error);
    }
};
